﻿import type { IsAddressProps, UpdateCellProps, ITableValidatorColumn } from './types';

export class TableValidator {
    private grid: kendo.ui.Grid;
    private columns: ITableValidatorColumn[];

    constructor(grid: kendo.ui.Grid, columns: ITableValidatorColumn[]) {
        this.grid = grid;
        this.columns = columns;

        grid.bind('cellClose', ({ container }: { container: Element[] }) => this.removeError(container[0]));
    }

    init() {
        const data = this.grid.dataSource.data();

        this.columns.forEach(({ key, message, validate }) => {
            const colIdx = this.grid.columns.map(col => col.field).indexOf(key);

            if (validate.includes('address')) {
                data.forEach((el: { uid: string, Longitude?: string, Latitude?: string }) =>
                    this.updateCell({
                        rowUid: el.uid,
                        colIdx,
                        message,
                        key,
                        isError: !this.isAddress(el)
                    }));
            }
        });

        return this.isValid();
    }

    updateCell({ rowUid, colIdx, message, key, isError, cellHtml }: UpdateCellProps) {
        const cell = cellHtml ?? document.querySelector(`[data-uid="${rowUid}"] td:nth-child(${colIdx + 1})`);
        if (!cell) return;

        if (!isError) {
            this.removeError(cell);
        }
        else {
            cell.setAttribute('data-validator-is-valid', 'false');
            cell.setAttribute('data-validator-key', key);
            cell.setAttribute('data-validator-message', message);
        }
    }

    isAddress({ Longitude: longitude, Latitude: latitude, Address: address }: IsAddressProps) {
        return !!longitude && !!latitude && !!address;
    }

    removeError(cell: Element) {
        cell.removeAttribute('data-validator-is-valid');
        cell.classList.remove('table-validator-error');
    }

    isValid() {
        const notValidCells = this.grid.tbody.find('[data-validator-is-valid="false"]');

        if (notValidCells.length) {
            notValidCells.each((_, cell) => {
                const el = $(cell);

                el.addClass('table-validator-error');
                el.find('.k-widget.k-tooltip-validation').remove();

                el.append($(window.validationMessageTmpl({
                    field: el.attr('data-validator-key'),
                    message: el.attr('data-validator-message')
                }))[0]);
            });

            setTimeout(() => $('.k-tooltip-validation').hide(), 3000);

            return false;
        }

        return true;
    }
}